import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { CContainer, CCard, CCardBody, CFormCheck, CButton, CAlert, CSpinner } from '@coreui/react';
import { toast } from 'react-toastify';
import Loading from '../Loading/Loading';
import { useTranslation } from 'react-i18next';
import CIcon from '@coreui/icons-react';
import { cilAccountLogout } from '@coreui/icons';
import LanguageSwitcher from '../LanguageSwitcher/LanguageSwitcher'; // <--- ИМПОРТ ПЕРЕКЛЮЧАТЕЛЯ

const TermsGuard = ({ children }) => {
    const [loading, setLoading] = useState(true);
    const [user, setUser] = useState(null);
    const [offerAccepted, setOfferAccepted] = useState(false);
    const [policyAccepted, setPolicyAccepted] = useState(false);
    const [saving, setSaving] = useState(false);
    const { t } = useTranslation();

    useEffect(() => {
        const fetchProfile = async () => {
            try {
                const token = localStorage.getItem('token');
                const res = await axios.get('/api/profile/', { headers: { 'Authorization': `Bearer ${token}` } });
                setUser(res.data);
            } catch (e) {
                console.error(e);
            } finally {
                setLoading(false);
            }
        };
        fetchProfile();
    }, []);

    const handleLogout = () => {
        localStorage.removeItem('token');
        window.location.href = '/login';
    };

    if (loading) return <Loading name={t('common.loading')} />;

    // Если у пользователя есть организация и она еще не приняла условия
    if (user && user.organization && !user.organization.has_accepted_terms) {
        
        // Если пользователь не админ, он не может принять условия
        if (!user.is_staff) {
            return (
                <div className="bg-light min-vh-100 d-flex flex-column align-items-center justify-content-center position-relative">
                    
                    {/* Кнопка смены языка в правом верхнем углу */}
                    <div className="position-absolute" style={{ top: '20px', right: '20px' }}>
                        <LanguageSwitcher />
                    </div>

                    <CContainer>
                        <CAlert color="warning" className="text-center shadow-sm p-4 mx-auto" style={{ maxWidth: '600px' }}>
                            <h4 className="mb-3">{t('terms.warning_title')}</h4>
                            <p className="fs-5">{t('terms.warning_text_1')}</p>
                            <p className="fs-5 fw-bold">{t('terms.warning_text_2')}</p>
                        </CAlert>
                        <div className="text-center mt-4">
                            <CButton color="secondary" onClick={handleLogout}>
                                <CIcon icon={cilAccountLogout} className="me-2" />{t('dashboard.logout')}
                            </CButton>
                        </div>
                    </CContainer>
                </div>
            );
        }

        const handleAccept = async () => {
            if (!offerAccepted || !policyAccepted) return;
            setSaving(true);
            try {
                const token = localStorage.getItem('token');
                await axios.patch('/api/organization/', { has_accepted_terms: true }, { headers: { 'Authorization': `Bearer ${token}` } });
                setUser({ ...user, organization: { ...user.organization, has_accepted_terms: true } });
                toast.success(t('common.success'));
            } catch (e) {
                toast.error(t('common.error'));
            } finally {
                setSaving(false);
            }
        };

        return (
            <div className="bg-light min-vh-100 d-flex flex-column align-items-center justify-content-center position-relative">
                
                {/* Кнопка смены языка в правом верхнем углу */}
                <div className="position-absolute" style={{ top: '20px', right: '20px' }}>
                    <LanguageSwitcher />
                </div>

                <CContainer>
                    <CCard className="p-4 mx-auto shadow-sm border-top-primary border-top-3" style={{ maxWidth: '600px' }}>
                        <CCardBody>
                            <h3 className="mb-3 text-center">{t('terms.title')}</h3>
                            <p className="text-muted text-center mb-4">{t('terms.subtitle')}</p>
                            
                            <div className="mb-3 p-3 border rounded bg-white">
                                <CFormCheck 
                                    id="offerCheck" 
                                    checked={offerAccepted} 
                                    onChange={(e) => setOfferAccepted(e.target.checked)}
                                    label={
                                        <span>
                                            {t('terms.offer_text')} <a href="/static/docs/offer.pdf" target="_blank" rel="noopener noreferrer">{t('terms.offer_link')}</a>
                                        </span>
                                    }
                                />
                            </div>

                            <div className="mb-4 p-3 border rounded bg-white">
                                <CFormCheck 
                                    id="policyCheck" 
                                    checked={policyAccepted} 
                                    onChange={(e) => setPolicyAccepted(e.target.checked)}
                                    label={
                                        <span>
                                            {t('terms.policy_text')} <a href="/static/docs/policy.pdf" target="_blank" rel="noopener noreferrer">{t('terms.policy_link')}</a>
                                        </span>
                                    }
                                />
                            </div>

                            <CButton 
                                color="primary" 
                                className="w-100 mb-3 fw-bold py-2" 
                                disabled={!offerAccepted || !policyAccepted || saving}
                                onClick={handleAccept}
                            >
                                {saving ? <CSpinner size="sm" /> : t('terms.btn_continue')}
                            </CButton>

                            <div className="text-center">
                                <CButton color="link" className="text-muted" onClick={handleLogout}>
                                    {t('dashboard.logout')}
                                </CButton>
                            </div>
                        </CCardBody>
                    </CCard>
                </CContainer>
            </div>
        );
    }

    // Если условия приняты, рендерим защищенный контент
    return children;
};

export default TermsGuard;